(function () {
  'use strict';

  if (window.__kailaColorSamplePickerInit) return;
  window.__kailaColorSamplePickerInit = true;

  var VOTE_STORAGE_KEY = 'ayami_color_vote_abuja';
  var ONBOARDING_FABRIC_FLOW_KEY = 'ayami_onboarding_fabric_flow';
  var ONBOARDING_BRIDGE_KEY = 'ayami_onboarding_bridge';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function getConfig(root) {
    return {
      cartUrl: root.getAttribute('data-cart-url') || '/cart',
      availableCount: parseInt(root.getAttribute('data-available-count') || '0', 10) || 0,
      addLabel: root.getAttribute('data-add-label') || 'Add to basket',
      addLabelOne: root.getAttribute('data-add-label-one') || 'Add 1 sample to basket',
      addLabelMany: root.getAttribute('data-add-label-many') || 'Add __COUNT__ samples to basket',
      selectAllLabel: root.getAttribute('data-select-all-label') || 'Select all',
      clearLabel: root.getAttribute('data-clear-label') || 'Clear',
      // Colour votes (custom.color_votes) are the source of truth for saved colours.
      profilePreselect: root.getAttribute('data-profile-preselect') !== 'false',
      onboardingBridgeUrl:
        root.getAttribute('data-onboarding-bridge-url') || '/pages/onboarding?from=fabric',
    };
  }

  function markOnboardingFabricFlowFromQuery() {
    try {
      var from = new URLSearchParams(window.location.search).get('from');
      if (from === 'comfort' || from === 'color-guide' || from === 'onboarding') {
        sessionStorage.setItem(ONBOARDING_FABRIC_FLOW_KEY, '1');
      }
    } catch (e) {}
  }

  function isOnboardingFabricFlow() {
    try {
      return sessionStorage.getItem(ONBOARDING_FABRIC_FLOW_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function continueToFabricOnboardingBridge(config) {
    try {
      sessionStorage.setItem(
        ONBOARDING_BRIDGE_KEY,
        JSON.stringify({ from: 'fabric', highlights: [] })
      );
      sessionStorage.removeItem(ONBOARDING_FABRIC_FLOW_KEY);
    } catch (e) {}
    window.location.href =
      (config && config.onboardingBridgeUrl) || '/pages/onboarding?from=fabric';
  }

  function parseJsonScript(id) {
    var scriptEl = document.getElementById(id);
    if (!scriptEl || !scriptEl.textContent || !scriptEl.textContent.trim()) return null;
    try {
      return JSON.parse(scriptEl.textContent);
    } catch (e) {
      return null;
    }
  }

  function normalizeKey(value) {
    return String(value || '')
      .toLowerCase()
      .trim()
      .replace(/['’]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function addInterestKey(set, value) {
    var key = normalizeKey(value);
    if (key) set[key] = true;
  }

  /** Load saved colours from colour votes only (source of truth). */
  function loadSavedVoteColors() {
    var interest = { codes: {}, slugs: {}, names: {} };
    var raw = parseJsonScript('ColorVoteSavedData');
    if (!raw) {
      try {
        var stored = localStorage.getItem(VOTE_STORAGE_KEY);
        if (stored) raw = JSON.parse(stored);
      } catch (e) {
        raw = null;
      }
    }
    if (!raw || typeof raw !== 'object') return null;

    var found = false;
    if (Array.isArray(raw.votes)) {
      raw.votes.forEach(function (code) {
        addInterestKey(interest.codes, code);
        found = true;
      });
    }
    if (Array.isArray(raw.vote_details)) {
      raw.vote_details.forEach(function (item) {
        if (!item) return;
        addInterestKey(interest.codes, item.vendor_code || item.vendorCode);
        addInterestKey(interest.slugs, item.slug);
        addInterestKey(interest.names, item.name);
        found = true;
      });
    }
    return found ? interest : null;
  }

  function cardMatchesInterest(card, interest) {
    if (!card || !interest) return false;
    var code = normalizeKey(card.getAttribute('data-vendor-code'));
    var slug = normalizeKey(card.getAttribute('data-color-slug'));
    var name = normalizeKey(card.getAttribute('data-color-name'));
    if (code && interest.codes[code]) return true;
    if (slug && interest.slugs[slug]) return true;
    if (name && (interest.names[name] || interest.slugs[name])) return true;
    if (slug && interest.names[slug]) return true;
    return false;
  }

  function preselectFromProfile(root, grid) {
    var interest = loadSavedVoteColors();
    if (!interest) return 0;

    var matched = availableCards(grid).filter(function (card) {
      return cardMatchesInterest(card, interest);
    });
    if (!matched.length) return 0;

    matched.forEach(function (card) {
      setCardSelected(card, true);
    });
    focusCard(root, grid, matched[0]);
    return matched.length;
  }

  function availableCards(grid) {
    return Array.prototype.slice.call(
      grid.querySelectorAll('[data-color-sample-card][data-available="true"]')
    );
  }

  function selectedCards(grid) {
    return availableCards(grid).filter(function (card) {
      var input = card.querySelector('[data-color-sample-input]');
      return input && input.checked;
    });
  }

  function setCardSelected(card, selected) {
    var input = card.querySelector('[data-color-sample-input]');
    var toggle = card.querySelector('button[data-color-sample-toggle]');
    var available = card.getAttribute('data-available') === 'true';
    if (!input || !available) return;
    input.checked = !!selected;
    card.classList.toggle('is-selected', !!selected);
    if (toggle) {
      toggle.textContent = selected ? 'Remove' : 'Add';
      toggle.setAttribute('aria-pressed', selected ? 'true' : 'false');
    }
  }

  function setFocusedCard(grid, card) {
    Array.prototype.forEach.call(grid.querySelectorAll('[data-color-sample-card]'), function (item) {
      item.classList.toggle('is-focused', item === card);
    });
  }

  function updateFocusVariant(root, variantId) {
    var focusInput = root.querySelector('[data-color-sample-focus-id]');
    if (!focusInput || !variantId) return;
    focusInput.value = String(variantId);
    try {
      focusInput.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (e) {
      var evt = document.createEvent('Event');
      evt.initEvent('change', true, true);
      focusInput.dispatchEvent(evt);
    }

    try {
      document.dispatchEvent(
        new CustomEvent('kaila:color-sample-focus', {
          bubbles: true,
          detail: { variantId: String(variantId), root: root },
        })
      );
    } catch (e) {
      /* ignore */
    }
  }

  function revealDescription(root) {
    var prompt = root.querySelector('[data-color-sample-descript-prompt]');
    var body = root.querySelector('[data-color-sample-descript-body]');
    if (prompt) prompt.classList.add('hidden');
    if (body) body.classList.remove('hidden');
  }

  function focusCard(root, grid, card) {
    if (!card) return;
    setFocusedCard(grid, card);
    revealDescription(root);
    updateFocusVariant(root, card.getAttribute('data-variant-id'));
  }

  function refreshUi(root, grid, config) {
    var selected = selectedCards(grid);
    var count = selected.length;
    var available = availableCards(grid);
    var selectAllBtn = root.querySelector('[data-color-sample-select-all]');
    var clearAllBtn = root.querySelector('[data-color-sample-clear-all]');
    var submitBtn = root.querySelector('[data-color-sample-submit]');
    var allSelected = available.length > 0 && count === available.length;

    if (selectAllBtn) {
      selectAllBtn.textContent = config.selectAllLabel;
      selectAllBtn.disabled = available.length === 0 || allSelected;
    }

    if (clearAllBtn) {
      clearAllBtn.textContent = config.clearLabel;
      clearAllBtn.disabled = count === 0;
    }

    if (submitBtn) {
      submitBtn.disabled = count === 0;
      if (count === 0) {
        submitBtn.textContent = config.addLabel;
      } else if (count === 1) {
        submitBtn.textContent = config.addLabelOne;
      } else {
        submitBtn.textContent = config.addLabelMany.replace('__COUNT__', String(count));
      }
    }
  }

  function showHint(root, message, isError) {
    var hint = root.querySelector('[data-color-sample-hint]');
    if (!hint) return;
    hint.textContent = message || '';
    hint.classList.toggle('is-error', !!isError && !!message);
  }

  function showOnboardingIntro(root) {
    var intro = root.querySelector('[data-color-sample-onboarding]');
    if (!intro) return;
    try {
      var params = new URLSearchParams(window.location.search);
      var from = params.get('from');
      if (from === 'color-vote' || from === 'color-guide' || from === 'comfort') {
        intro.classList.remove('hidden');
      }
    } catch (e) {
      /* ignore */
    }
  }

  function shouldSelectAllFromQuery() {
    try {
      var params = new URLSearchParams(window.location.search);
      return (
        params.get('select') === 'all' ||
        params.get('from') === 'color-guide' ||
        params.get('from') === 'comfort'
      );
    } catch (e) {
      return false;
    }
  }

  function selectAllFromQuery(root, grid) {
    if (!shouldSelectAllFromQuery()) return 0;
    var cards = availableCards(grid);
    if (!cards.length) return 0;
    cards.forEach(function (card) {
      setCardSelected(card, true);
    });
    focusCard(root, grid, cards[0]);
    return cards.length;
  }

  function addItemsToCart(items) {
    return fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items }),
    }).then(function (res) {
      return res.text().then(function (text) {
        var body = {};
        if (text) {
          try {
            body = JSON.parse(text);
          } catch (e) {
            var parseError = new Error('Could not add samples to basket');
            parseError.status = res.status;
            throw parseError;
          }
        }
        if (!res.ok) {
          var error = new Error(body.description || body.message || 'Could not add samples to basket');
          error.status = res.status;
          error.detail = body.description || body.message || null;
          throw error;
        }
        return body;
      });
    });
  }

  function initRoot(root) {
    if (!root || root.__colorSamplePickerBound) return;
    root.__colorSamplePickerBound = true;

    var form = root.querySelector('[data-color-sample-form]');
    var grid = root.querySelector('[data-color-sample-grid]');
    var selectAllBtn = root.querySelector('[data-color-sample-select-all]');
    var clearAllBtn = root.querySelector('[data-color-sample-clear-all]');
    var submitBtn = root.querySelector('[data-color-sample-submit]');
    if (!form || !grid) return;

    var config = getConfig(root);
    markOnboardingFabricFlowFromQuery();
    showOnboardingIntro(root);
    if (config.profilePreselect) {
      preselectFromProfile(root, grid);
    }
    selectAllFromQuery(root, grid);
    refreshUi(root, grid, config);

    grid.addEventListener('click', function (event) {
      var previewBtn = event.target.closest('[data-color-sample-preview]');
      var toggleBtn = event.target.closest('button[data-color-sample-toggle]');
      var card = event.target.closest('[data-color-sample-card]');
      if (!card || !grid.contains(card)) return;

      if (toggleBtn) {
        event.preventDefault();
        if (card.getAttribute('data-available') !== 'true') return;
        var input = card.querySelector('[data-color-sample-input]');
        setCardSelected(card, !(input && input.checked));
        focusCard(root, grid, card);
        showHint(root, '', false);
        refreshUi(root, grid, config);
        return;
      }

      if (previewBtn || card) {
        event.preventDefault();
        if (card.getAttribute('data-available') === 'true') {
          var cardInput = card.querySelector('[data-color-sample-input]');
          var isSelected = !!(cardInput && cardInput.checked);
          // Clicking a colour selects it and shows its description;
          // clicking the colour that is already shown again removes it.
          if (!isSelected) {
            setCardSelected(card, true);
          } else if (card.classList.contains('is-focused')) {
            setCardSelected(card, false);
          }
          showHint(root, '', false);
          refreshUi(root, grid, config);
        }
        focusCard(root, grid, card);
      }
    });

    function applyBulkSelection(selectAll) {
      var cards = availableCards(grid);
      cards.forEach(function (card) {
        setCardSelected(card, selectAll);
      });
      var focused = grid.querySelector('[data-color-sample-card].is-focused') || cards[0];
      if (focused && selectAll) {
        focusCard(root, grid, focused);
      }
      showHint(root, '', false);
      refreshUi(root, grid, config);
    }

    if (selectAllBtn) {
      selectAllBtn.addEventListener('click', function () {
        applyBulkSelection(true);
      });
    }

    if (clearAllBtn) {
      clearAllBtn.addEventListener('click', function () {
        applyBulkSelection(false);
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var selected = selectedCards(grid);
      if (!selected.length) {
        showHint(root, 'Select at least one colour sample.', true);
        return;
      }

      var items = selected.map(function (card) {
        return {
          id: Number(card.getAttribute('data-variant-id')),
          quantity: 1,
        };
      });

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-busy', 'true');
      }
      showHint(root, 'Adding to basket…', false);

      addItemsToCart(items)
        .then(function () {
          // Onboarding visitors continue to the step bridge; everyone else goes to cart.
          if (
            root.getAttribute('data-profile-preselect') === 'false' &&
            isOnboardingFabricFlow()
          ) {
            continueToFabricOnboardingBridge(config);
            return;
          }
          window.location.href = config.cartUrl;
        })
        .catch(function (error) {
          showHint(
            root,
            (error && (error.detail || error.message)) || 'Could not add samples to basket. Please try again.',
            true
          );
          refreshUi(root, grid, config);
          if (submitBtn) {
            submitBtn.removeAttribute('aria-busy');
          }
        });
    });
  }

  function initAll(scope) {
    var rootScope = scope && scope.querySelectorAll ? scope : document;
    rootScope.querySelectorAll('[data-color-sample-picker]').forEach(initRoot);
  }

  ready(function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
